import { useMemo, useState } from 'react'
import InformacoesHorarioSaidaHttp from '../../../../services/api/https/deliveries/horario-saida.http'
import { getMotivoAtraso } from '../../../../services/api/https/registration/motivo-atraso.http'
import { getTps, getUsuarioInfo } from '../../../../services/localstorage/localstorage.service'
import { errorHandler } from '../../../../services/util/error.service'
import { MOTIVO_ATRASO_URL_TYPES } from '../../Cadastros/MotivoAtraso/MotivoAtrasoHook'

export const LOAD_MESSAGE = {
  NONE: 'NONE',
  GET_INITIAL_INFO: 'Adquirindo frotas',
  SAVE_DEPARTURE_TIME: 'Salvando informações',
  SUCCESS: 'Informações salvas com sucesso',
}

const INITIAL_STATE = {
  frotas: [],
  motivosAtraso: [],
  globalFilter: '',
  departureTimeWithReason: {},
  loadingMessage: LOAD_MESSAGE.NONE,
  errorMessage: null,
}

export default function useInformacoesHorarioSaida() {
  const [state, setState] = useState({ ...INITIAL_STATE })

  const localDispatch = useMemo(() => {
    //Helpers

    return {
      //Actions
      resetState() {
        setState(prevState => ({
          ...prevState,
          loadingMessage: LOAD_MESSAGE.NONE,
          errorMessage: null,
        }))
      },

      async saveDepartureTimeInfo(selectedTp, departureTimeWithReason, frotas) {
        const selectedFrotasIds = frotas.filter(f => f.selected).map(f => f.fleet_id)
        if (!selectedFrotasIds.length)
          setState(prevState => ({
            ...prevState,
            errorMessage: 'Selecione pelo menos 1 item para atribuir as informações.',
          }))
        else
          await InformacoesHorarioSaidaHttp.saveDepartureTimeFleetsInfo(selectedTp, {
            infos: departureTimeWithReason,
            fleetsIds: selectedFrotasIds,
          })
            .then(fetchedFrotas =>
              setState(prevState => ({
                ...prevState,
                frotas: fetchedFrotas,
                loadingMessage: LOAD_MESSAGE.SUCCESS,
              })),
            )
            .catch(err =>
              setState(prevState => ({
                ...prevState,
                errorMessage: errorHandler(err),
                loadingMessage: LOAD_MESSAGE.NONE,
              })),
            )
      },

      async getFleets(selectedTp) {
        await InformacoesHorarioSaidaHttp.getFleetsToDepartureTime(selectedTp)
          .then(fleets => setState(prevState => ({ ...prevState, frotas: fleets })))
          .catch(err =>
            setState(prevState => ({
              ...prevState,
              errorMessage: errorHandler(err),
              loadingMessage: LOAD_MESSAGE.NONE,
            })),
          )
      },

      async getMotivosAtraso(selectedTp) {
        let tps = selectedTp
        if (!tps) tps = getTps(false).map(tp => tp.id)
        getMotivoAtraso(getUsuarioInfo().id, tps, MOTIVO_ATRASO_URL_TYPES.VEICULO_T2)
          .then(motivos =>
            setState(prevState => ({
              ...prevState,
              motivosAtraso: motivos,
              loadingMessage: LOAD_MESSAGE.NONE,
            })),
          )
          .catch(err =>
            setState(prevState => ({
              ...prevState,
              errorMessage: errorHandler(err),
              loadingMessage: LOAD_MESSAGE.NONE,
            })),
          )
      },

      //Events
      onGlobalFilterChange(value) {
        setState(prevState => ({ ...prevState, globalFilter: value }))
      },

      onCheckBoxRowClicked(frota, checked) {
        setState(prevState => {
          const index = prevState.frotas.findIndex(f => f.fleet_id === frota.fleet_id)
          if (index !== -1) {
            prevState.frotas[index].selected = checked
          }
          return { ...prevState }
        })
      },

      onInit(selectedTp) {
        if (!selectedTp) setState(prevState => ({ ...prevState, errorMessage: 'Selecione um TP' }))
        else
          setState(prevState => ({ ...prevState, loadingMessage: LOAD_MESSAGE.GET_INITIAL_INFO }))
      },

      onBtnSalvarInfo(departureTimeWithReason) {
        setState(prevState => ({
          ...prevState,
          departureTimeWithReason: departureTimeWithReason,
          loadingMessage: LOAD_MESSAGE.SAVE_DEPARTURE_TIME,
        }))
      },
    }
  }, [])

  return { state, localDispatch }
}
